import {useQueryClient} from "react-query";
import useLazyQuery from "@utils/useLazyQuery";
import {KEYS} from "@app/constants/keys";
import {
    BrandManualDashboardGetApi,
    BrandNoticeDashboardGetApi,
    BrandRegisteredUserDashboardApi,
    BrandRegisteredUserGraphDashboardApi,
    BrandUsageCompanyDashboardGetApi,
    BrandUsageShopDashboardGetApi,
    CafeDeviceDashboardGetApi,
    CafeManualDashboardGetApi,
    CafeNoticeDashboardGetApi,
    CafeOperationDashboardGetApi,
    CafeOrderByTimeDashboardGetApi,
    DiningCongestionDashboardPutApi,
    DiningCourseSoldOutDashboardPutApi,
    DiningCourseStatusDashboardGetApi,
    DiningDeviceDashboardGetApi,
    DiningManualDashboardGetApi,
    DiningNoticeDashboardGetApi,
    DiningOperationDashboardGetApi,
    DiningOrderByTimeDashboardGetApi,
    DiningShopStateDashboardGetApi
} from "@services/dataSource/dashboardApi";
import {
    BrandManualDashboardPayload,
    BrandNoticeDashboardPayload,
    BrandRegisteredUserDashboardPayload,
    BrandRegisteredUserGraphDashboardPayload,
    BrandUsageCompanyDashboardPayload,
    BrandUsageShopDashboardPayload,
    CafeDeviceDashboardPayload,
    CafeManualDashboardPayload,
    CafeNoticeDashboardPayload,
    CafeOperationDashboardPayload,
    CafeOrderByTimeDashboardPayload,
    DiningCongestionUpdatePayload,
    DiningCourseStatusDashboardPayload,
    DiningDeviceDashboardPayload,
    DiningManualDashboardPayload,
    DiningMealSoldOutUpdatePayload,
    DiningNoticeDashboardPayload,
    DiningOperationDashboardPayload,
    DiningOrderByTimeDashboardPayload,
    DiningShopStatusDashboardPayload
} from "@services/entities/dashboardEntity";
import useCustomMutation from "@utils/useCustomMutation";

export const DashboardRepository = () => {
    const queryClient = useQueryClient();

    //cafe manual dashboard
    const [fetchCafeManualDashboardData, cafeManualDashboardData] = useLazyQuery<CafeManualDashboardPayload>(KEYS.QUERY.dashboard.cafe.manual, CafeManualDashboardGetApi);
    //cafe operation dashboard
    const [fetchCafeOperationDashboardData, cafeOperationDashboardData] = useLazyQuery<CafeOperationDashboardPayload>(KEYS.QUERY.dashboard.cafe.operation, CafeOperationDashboardGetApi);
    //cafe notice dashboard
    const [fetchCafeNoticeDashboardData, cafeNoticeDashboardData] = useLazyQuery<CafeNoticeDashboardPayload>(KEYS.QUERY.dashboard.cafe.notice, CafeNoticeDashboardGetApi);
    //cafe order by time dashboard
    const [fetchCafeOrderByTimeDashboardData, cafeOrderByTimeDashboardData] = useLazyQuery<CafeOrderByTimeDashboardPayload>(KEYS.QUERY.dashboard.cafe.orderByTime, CafeOrderByTimeDashboardGetApi);
    //cafe device dashboard
    const [fetchCafeDeviceDashboardData, cafeDeviceDashboardData] = useLazyQuery<CafeDeviceDashboardPayload>(KEYS.QUERY.dashboard.cafe.device, CafeDeviceDashboardGetApi);


    //dining manual dashboard
    const [fetchDiningManualDashboardData, diningManualDashboardData] = useLazyQuery<DiningManualDashboardPayload>(KEYS.QUERY.dashboard.dining.manual, DiningManualDashboardGetApi);
    //dining notice dashboard
    const [fetchDiningNoticeDashboardData, diningNoticeDashboardData] = useLazyQuery<DiningNoticeDashboardPayload>(KEYS.QUERY.dashboard.dining.notice, DiningNoticeDashboardGetApi);
    //dining device dashboard
    const [fetchDiningDeviceDashboardData, diningDeviceDashboardData] = useLazyQuery<DiningDeviceDashboardPayload>(KEYS.QUERY.dashboard.dining.device, DiningDeviceDashboardGetApi);
    //dining order by time dashboard
    const [fetchDiningOrderByTimeDashboardData, diningOrderByTimeDashboardData] = useLazyQuery<DiningOrderByTimeDashboardPayload>(KEYS.QUERY.dashboard.dining.orderByTime, DiningOrderByTimeDashboardGetApi);
    //dining shop status dashboard
    const [fetchDiningShopStatusDashboard, diningShopStatusDashboardData] = useLazyQuery<DiningShopStatusDashboardPayload>(KEYS.QUERY.dashboard.dining.shopState, DiningShopStateDashboardGetApi);
    //dining operation dashboard
    const [fetchDiningOperationDashboard, diningOperationDashboardData] = useLazyQuery<DiningOperationDashboardPayload>(KEYS.QUERY.dashboard.dining.operation, DiningOperationDashboardGetApi);
    //dining course status dashboard
    const [fetchDiningCourseStatusDashboard, diningCourseStatusDashboardData] = useLazyQuery<DiningCourseStatusDashboardPayload>(KEYS.QUERY.dashboard.dining.courseStatus, DiningCourseStatusDashboardGetApi);

    //dining course status update
    const [diningCourseCongestionEditMutate] = useCustomMutation<DiningCongestionUpdatePayload>(DiningCongestionDashboardPutApi);

    //dining meal soldout update
    const [diningMealSoldOutEditMutate] = useCustomMutation<DiningMealSoldOutUpdatePayload>(DiningCourseSoldOutDashboardPutApi);

    //brand usage shop dashboard
    const [fetchBrandUsageShopDashboardData, brandUsageShopDashboardData] = useLazyQuery<BrandUsageShopDashboardPayload>(KEYS.QUERY.dashboard.brand.usageShop, BrandUsageShopDashboardGetApi);
    //brand usage company dashboard
    const [fetchBrandUsageCompanyDashboardData, brandUsageCompanyDashboardData] = useLazyQuery<BrandUsageCompanyDashboardPayload>(KEYS.QUERY.dashboard.brand.usageCompany, BrandUsageCompanyDashboardGetApi);
    //brand notice dashboard
    const [fetchBrandNoticeDashboardData, brandNoticeDashboardData] = useLazyQuery<BrandNoticeDashboardPayload>(KEYS.QUERY.dashboard.brand.notice, BrandNoticeDashboardGetApi);
    //brand manual dashboard
    const [fetchManualNoticeDashboardData, brandManualDashboardData] = useLazyQuery<BrandManualDashboardPayload>(KEYS.QUERY.dashboard.brand.manual, BrandManualDashboardGetApi);
    //brand registered dashboard
    const [fetchRegisteredDashboardData, brandRegisteredDashboardData] = useLazyQuery<BrandRegisteredUserDashboardPayload>(KEYS.QUERY.dashboard.brand.registered, BrandRegisteredUserDashboardApi);
    //brand registered graph dashboard
    const [fetchRegisteredGraphDashboardData, brandRegisteredGraphDashboardData] = useLazyQuery<BrandRegisteredUserGraphDashboardPayload>(KEYS.QUERY.dashboard.brand.graph, BrandRegisteredUserGraphDashboardApi);

    const getCafeManualDashboard = ({page}: CafeManualDashboardPayload) => {
        const data: CafeManualDashboardPayload = {
            page
        }
        fetchCafeManualDashboardData(data);
    }

    const getCafeOperationDashboard = ({shopId, opDate}: CafeOperationDashboardPayload) => {
        const data: CafeOperationDashboardPayload = {
            shopId,
            opDate
        }
        fetchCafeOperationDashboardData(data);
    }

    const getCafeNoticeDashboard = ({brandCode, shopId, page}: CafeNoticeDashboardPayload) => {
        const data: CafeNoticeDashboardPayload = {
            brandCode,
            shopId,
            page
        }
        fetchCafeNoticeDashboardData(data);
    }

    const getCafeOrderByTimeDashboard = ({
                                             shopId,
                                             startOpDate,
                                             endOpDate,
                                             timeUnit,
                                             startTime,
                                             endTime
                                         }: CafeOrderByTimeDashboardPayload) => {
        const data: CafeOrderByTimeDashboardPayload = {
            shopId,
            startOpDate,
            endOpDate,
            timeUnit,
            startTime,
            endTime
        }
        fetchCafeOrderByTimeDashboardData(data);
    }

    const getCafeDeviceDashboard = ({shopId}: CafeDeviceDashboardPayload) => {
        const data: CafeDeviceDashboardPayload = {
            shopId
        }
        fetchCafeDeviceDashboardData(data);
    }

    const getDiningManualDashboard = ({page}: DiningManualDashboardPayload) => {
        const data: DiningManualDashboardPayload = {
            page
        }
        fetchDiningManualDashboardData(data);
    }

    const getDiningNoticeDashboard = ({brandCode, shopId, page}: DiningNoticeDashboardPayload) => {
        const data: DiningNoticeDashboardPayload = {
            brandCode,
            shopId,
            page,
        }
        fetchDiningNoticeDashboardData(data);
    }

    const getDiningDeviceDashboard = ({shopId}: DiningDeviceDashboardPayload) => {
        const data: DiningDeviceDashboardPayload = {
            shopId
        }
        fetchDiningDeviceDashboardData(data);
    }

    const getDiningOrderByTimeDashboard = ({
                                               shopId,
                                               startOpDate,
                                               endOpDate,
                                               timeUnit,
                                               startTime,
                                               endTime
                                           }: DiningOrderByTimeDashboardPayload) => {
        const data: DiningOrderByTimeDashboardPayload = {
            shopId,
            startOpDate,
            endOpDate,
            timeUnit,
            startTime,
            endTime
        }
        fetchDiningOrderByTimeDashboardData(data);
    }

    const getDiningShopStatusDashboard = ({shopId, opDate}: DiningShopStatusDashboardPayload) => {
        const data: DiningShopStatusDashboardPayload = {
            shopId,
            opDate
        }
        fetchDiningShopStatusDashboard(data);
    }

    const getDiningOperationDashboard = ({shopId, currentDate, currentTime}: DiningOperationDashboardPayload) => {
        const data: DiningOperationDashboardPayload = {
            shopId, currentDate, currentTime
        }
        fetchDiningOperationDashboard(data);
    }

    const getDiningCourseStatusDashboard = ({shopId, currentDate, currentTime}: DiningCourseStatusDashboardPayload) => {
        const data: DiningCourseStatusDashboardPayload = {
            shopId, currentDate, currentTime
        }
        fetchDiningCourseStatusDashboard(data);
    }

    const onCourseCongestionEdit = ({mealCourseId, congestionType}: DiningCongestionUpdatePayload) => {
        const data: DiningCongestionUpdatePayload = {
            mealCourseId,
            congestionType,
            callback: async () => {
                await queryClient.invalidateQueries(KEYS.QUERY.dashboard.dining.operation, {refetchInactive: true});
            }
        }
        diningCourseCongestionEditMutate(data);
    }

    const onMealSoldOutEdit = ({mealId, soldOutYn}: DiningMealSoldOutUpdatePayload) => {
        const data: DiningMealSoldOutUpdatePayload = {
            mealId,
            soldOutYn,
            callback: async () => {
                await queryClient.invalidateQueries(KEYS.QUERY.dashboard.dining.courseStatus, {refetchInactive: true});
            }
        }
        diningMealSoldOutEditMutate(data);
    }


    const getBrandUsageShopDashboard = ({opDate, brandCode}: BrandUsageShopDashboardPayload) => {
        const data: BrandUsageShopDashboardPayload = {
            opDate, brandCode
        }
        fetchBrandUsageShopDashboardData(data);
    }

    const getBrandUsageCompanyDashboard = ({opDate, brandCode}: BrandUsageCompanyDashboardPayload) => {
        const data: BrandUsageCompanyDashboardPayload = {
            opDate, brandCode
        }
        fetchBrandUsageCompanyDashboardData(data);
    }

    const getBrandNoticeDashboard = ({brandCode, page}: BrandNoticeDashboardPayload) => {
        const data: BrandNoticeDashboardPayload = {
            brandCode,
            page
        }
        fetchBrandNoticeDashboardData(data);
    }

    const getBrandManualDashboard = ({page}: BrandManualDashboardPayload) => {
        const data: BrandManualDashboardPayload = {
            page
        }
        fetchManualNoticeDashboardData(data);
    }

    const getBrandRegisteredDashboard = ({brandCode}: BrandRegisteredUserDashboardPayload) => {
        const data: BrandRegisteredUserDashboardPayload = {
            brandCode
        }
        fetchRegisteredDashboardData(data);
    }

    const getBrandRegisteredGraphDashboard = ({brandCode}: BrandRegisteredUserGraphDashboardPayload) => {
        const data: BrandRegisteredUserGraphDashboardPayload = {
            brandCode
        }
        fetchRegisteredGraphDashboardData(data);
    }

    return {
        getCafeManualDashboard,
        getCafeOperationDashboard,
        getCafeNoticeDashboard,
        getCafeOrderByTimeDashboard,
        getCafeDeviceDashboard,
        cafeDeviceDashboardData,
        cafeManualDashboardData,
        cafeOperationDashboardData,
        cafeNoticeDashboardData,
        cafeOrderByTimeDashboardData,

        getDiningManualDashboard,
        getDiningNoticeDashboard,
        getDiningDeviceDashboard,
        getDiningOrderByTimeDashboard,
        getDiningShopStatusDashboard,
        getDiningOperationDashboard,
        getDiningCourseStatusDashboard,
        onCourseCongestionEdit,
        onMealSoldOutEdit,
        diningManualDashboardData,
        diningNoticeDashboardData,
        diningDeviceDashboardData,
        diningOrderByTimeDashboardData,
        diningShopStatusDashboardData,
        diningOperationDashboardData,
        diningCourseStatusDashboardData,

        getBrandUsageShopDashboard,
        getBrandUsageCompanyDashboard,
        getBrandNoticeDashboard,
        getBrandManualDashboard,
        getBrandRegisteredDashboard,
        getBrandRegisteredGraphDashboard,
        brandUsageShopDashboardData,
        brandUsageCompanyDashboardData,
        brandNoticeDashboardData,
        brandManualDashboardData,
        brandRegisteredDashboardData,
        brandRegisteredGraphDashboardData
    }
}